import { useState, useContext, useEffect } from "react"
import { gql, useLazyQuery, useQuery } from "@apollo/client"
import { LoaderMedium } from "../Loaders"
import _ from "lodash"

// Context
import { UserContext } from "../../context/userContext"
import { FirebaseContext } from "../../firebase"

import defaultLogo from "../../assets/images/default-logo2.jpg"

export default function OrganizationLogo() {
  const userCtx = useContext(UserContext)
  const firebase = useContext(FirebaseContext)
  const [loading, setLoading] = useState(false)
  const [logoUrl, setLogoUrl] = useState("")

  const { getStorage, ref, getDownloadURL } = firebase.storage
  const storage = getStorage()

  const { organization_alias } = userCtx.session.user

  const GET_ORGANIZATION = gql`
    query getOrganization($staff_id: ID!, $organization_id: ID!) {
      organization(staff_id: $staff_id, organization_id: $organization_id) {
        organization_id
        organization_name
        organization_logo
      }
    }
  `
  useQuery(GET_ORGANIZATION, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    onCompleted: async ({ organization }) => {
      setLoading(true)

      const getLogoUrl = async () => {
        const organizationLogo = organization?.organization_logo

        if (!_.isEmpty(organizationLogo)) {
          const logoRef = ref(storage, organizationLogo)
          return await getDownloadURL(logoRef)
        }
        return null
      }

      const fetchLogo = async () => {
        const logo = await getLogoUrl()
        const logoUrl = _.isEmpty(logo) ? defaultLogo : logo
        setLogoUrl(logoUrl)
        setLoading(false)
      }
      fetchLogo()
    },
  })

  // useEffect(() => {

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [organization_alias])

  if (loading) return <LoaderMedium />

  return (
    <img
      src={logoUrl}
      alt=""
      style={{ width: "100%", margin: "20px 0 60px" }}
    />
  )
}
